export default __webpack_public_path__ + "static/media/home-slide1.ec16f6fd.png";